<template>
	<transition name="fade" v-if="config.show">

		<div class="modal-box">
			<div class="modal modal-lg p-0">
				<div class="modal-header clearfix">
					<h2 class="pull-left">
						수기 수강등록 (원내)
					</h2>
					<a class="close" @click="$emit('close')">×</a>
				</div>
				<div class="modal-body p-0 clearfix">
					<div class="box left">
						<p class="form-tit m-b-0">수강생 정보</p>
						<div class="round m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									이름
								</span>
								<input class="form-control full-width b-l-0" type="text" v-model="mber.mberName">
							</div>
						</div>
						<div class="round m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									휴대전화
								</span>
								<input class="form-control full-width round b-l-0" type="text" v-model="mber.mobileNum">
							</div>
						</div>
						<div class="round m-b-10">
							<div class="input-group full-width">
								<span class="input-group-addon label not bg-blue v-mid text-white">
									전자우편
								</span>
								<input class="form-control full-width round" type="text" v-model="mber.email">
							</div>
						</div>
					</div>
					<div class="box right">
						<p class="form-tit m-0">신청인(인솔자)</p>
						<div class="input-group full-width round m-b-10">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 이름
							</span>
							<input class="form-control" type="text" v-model="appl.applInfoList.find(e=>e.itemName=='이름').itemValue">
						</div>
						<div class="input-group full-width round m-b-10">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 휴대전화
							</span>
							<input class="form-control" type="text" placeholder="'-'없이 번호 입력" v-model="appl.applInfoList.find(e=>e.itemName=='휴대전화').itemValue">
						</div>
						<div class="input-group full-width round m-b-30">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 전자우편
							</span>
							<input class="form-control" type="text" v-model="appl.applInfoList.find(e=>e.itemName=='전자우편').itemValue">
						</div>
						<div class="input-group full-width round m-b-5">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img class="v-mid m-r-10" src="images/s-check.png" alt=""> 수강생 직업
							</span>
							<select class="form-control" v-model="appl.applInfoList.find(e=>e.itemName=='직업').itemValue">
								<option v-for="job in jobs" :key="'modal-apply-manual-online-job-'+hash(job)" :value="job.code">{{job.codeNm}}</option>
							</select>
						</div>
						<p class="form-tit m-0">신청기관</p>
						<div class="input-group full-width round">
							<span class="input-group-addon label not bg-blue v-mid text-white">
								소속기관
							</span>
							<input class="form-control" type="text" v-model="appl.applInfoList.find(e=>e.itemName=='소속기관').itemValue" @keydown="clearInstitution">
							<span class="input-group-addon v-mid" style="width:50px;">
								<button class="btn btn-darkgray round m-l-5" @click="showInstitution">검색</button>
							</span>
						</div>
						<p class="form-tit m-0">식당</p>
						<div class="input-group full-width round">
							<span class="input-group-addon label bg-blue v-mid text-white">
								<img src="images/s-check.png" alt="" class="v-mid m-r-10"> 원내 식당
							</span>
							<input class="form-control" type="text" v-model="appl.applInfoList.find(e=>e.itemName=='원내식당').itemValue" @keydown="clearInstitution">
						</div>
						<button class="btn bg-deepblue text-white full-width round m-t-30" @click="apply">신청완료</button>
						<br>
						<br>
						<br>
						<br>
						<br>
					</div>
				</div>
			</div>

			<ModalInstitutionSearch @selected="setInstitution" @close="modals.ModalInstitutionSearch.show=false" :config="modals.ModalInstitutionSearch" :key="'modal-apply-manual-type-income-institution'"></ModalInstitutionSearch>
		</div>
	</transition>
</template>

<script>
import axios from "axios";
import server from "../statics/server.js";
import moment from 'moment';
import ModalInstitutionSearch from './ModalInstitutionSearch.vue'

export default {
	name: "ModalApplyManualTypeIncome",

	components: {
		ModalInstitutionSearch
	},

	default: function() {
		return {
			name: this.name,
			lecId: 0,
			show: false,
		}
	},

	mounted: function() {
		// 직업분류 얻기
		axios.post(`${server.addr()}${server.api.COMMON_CODE}`, {
			codeId : "FIL001"
		}).then((response) => {
			this.jobs = response.data.list;
		})
	},

	data: function() {
		return {
			jobs: [],
			modals: {
				ModalInstitutionSearch: ModalInstitutionSearch.default()
			},
			mber: {
				mberId: "sys*@"+moment(),
				mberName: "",
				mobileNum: "",
				email: "",
				sklstfEnable: 0
			},
			appl: {
				lecId: 0,
				mberId: "",
				mberName: "",
				applStatus: "승인",
				acceptDate: moment().format("YYYY-MM-DD"),
				certStatus: "미수료",
				applInfoList: [
					{itemName: "이름", itemValue: ""},
					{itemName: "휴대전화", itemValue: ""},
					{itemName: "전자우편", itemValue: ""},
					{itemName: "직업", itemValue: ""},
					{itemName: "소속기관", itemValue: ""},
					{itemName: "agencyId", itemValue: ""},
					{itemName: "원내식당", itemValue: ""},
				],
				applEduDateList: []
			}
		}
	},

	props: {
		config: Object
	},

	methods: {
		apply: function() {
			// 비회원 등록
			axios.put(server.addr()+server.api.MBER, [this.mber]).then(() => {
				// 수강등록
				this.appl.lecId = this.config.lecId;
				this.appl.mberId = this.mber.mberId;
				this.appl.mberName = this.mber.mberName;
				this.appl.applEduDateList.push({
					eduStartDate: this.config.lec.lecEduDateList[0].eduStartDate,
					eduEndDate: this.config.lec.lecEduDateList[0].eduEndDate,
				})
				axios.put(server.addr()+server.api.APPL, [this.appl]).then(() => {
					this.$emit("done");
					this.config.show = false;
				});
			})
		},
		showInstitution: function() {
			this.modals.ModalInstitutionSearch.show = true;
		},
		setInstitution: function(inst) {
			this.appl.applInfoList.find(e=>e.itemName=='소속기관').itemValue = inst.agencyName;
			this.appl.applInfoList.find(e=>e.itemName=='agencyId').itemValue = inst.agencyId;
			this.modals.ModalInstitutionSearch.show = false;
		},
		clearInstitution: function() {
			this.appl.applInfoList.find(e=>e.itemName=='agencyId').itemValue = "";
		}
	}
};
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
